export default [
    {
        label: "Page Permissions",
        icon: "icon-folder",
        settingsKey: "pages",//IMPORTANT: this key is used to point out which optable settings will be use in the popup
        //this should match the key in option table/tableSettings.js
        show: true, //whether to show this in the edit table 
        tableSettings: {
            route: "mypages",
            formType: "popup",
            showItemPerPageOption: false,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "",
            },
            filterEndpoint: "myPages",
            showAddBtnDefault: true,
            showActionButtonDefault: true, //if this is false the add and edit button will not be shown 
            showEditBtnDefault: false,
            //change the default above, the one below will be overwriten during run time
            showAddBtn: false,
            showActionButton: false,
            showEditBtn: false,
        },
    },

] 